/**
 * Convert an array of flat objects to CSV and trigger a browser download.
 * By default the first row's keys become the column headers; pass `headers`
 * explicitly when rows may omit columns (e.g. sparse period breakdowns).
 * Double-quotes within cell values are escaped as per RFC 4180.
 *
 * @example
 *   exportToCsv([{ month: 'Sep', queries: 693951 }], 'report.csv')
 *   // downloads: "month","queries"\n"Sep","693951"
 */
export function exportToCsv(
  data: Record<string, any>[],
  filename: string,
  headers?: string[]
): void {
  if (!data.length) return;

  const resolvedHeaders = headers && headers.length ? headers : Object.keys(data[0]);
  const csvRows = [
    resolvedHeaders.map(h => `"${h}"`).join(','),
    ...data.map(row =>
      resolvedHeaders
        .map(h => `"${String(row[h] ?? '').replace(/"/g, '""')}"`)
        .join(',')
    ),
  ];

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
